import cn from 'classnames'
import { NavLink } from 'react-router-dom'

import { Button } from '@src/components/Button/Button'
import { ReactComponent as Error } from '@src/images/error.svg'
import style from '@src/pages/Errors/Error404.module.scss'
import { Footer } from '@src/components/Footer/Footer'

export const Error404 = () => (
  <div className={cn('container', style.containerError404)}>
    <div className={style.errorPage}>
      <Error />
      <p>К сожалению такой страницы не существует</p>
      <NavLink
        to="/my-profile"
      >
        <Button className={style.btnSize}>Вернуться на главную</Button>
      </NavLink>
    </div>
    <Footer />
  </div>
)
